import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './Header';
import $ from "jquery";
import Dashboard from './Dashboard';
import Course_Single from './Course_Single';
import Diet_Single from './Diet_Single';
import Training_Single from './Training_Single';
import Orders from './Orders';
import Cart from './Cart';
import CartSub from './CartSub';
import Profile from './Profile';
import Profile_Edit from './Profile_Edit';
import Notfy from './Notfy';
import Transaction from './Transaction';
import My_Diet from './My_Diet';
import My_Training from './My_Training';
import Live from './Live';
import Page from './Page';
import Page_list from './Page_list';
import Blog from './Blog';
import Blog_single from './Blog_single';


// import Sidebar from './Sidebar';
// import Package from './Package';
// import Profile from './Profile';
// import Signal from './Signal';
// import Hold from './Hold';
// import Temp from './Temp';
// import Wallet from './Wallet';

// import News from './News';
 import P_404 from './P_404';



export default class Main extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
     
                theme: localStorage.getItem('theme'),
        };
    }


    componentDidMount() {
        if (this.state.theme === 'light') {
            $('body').attr('data-theme-version', 'light').removeClass('rs-theme-dark').addClass('rs-theme-light');

        }
        else {
            $('body').attr('data-theme-version', 'dark').removeClass('rs-theme-light').addClass('rs-theme-dark');

        }


    }




    render() {
        
        return (
            

            
            <div id="main-wrapper">

            <Header />
        



                <div className="content-body">

     
                     <Routes>
                        
                         <Route path="/"  element={<Dashboard />} /> 
                         <Route path="/live/:id"  element={<Live />} /> 
                         <Route path="/page"  element={<Page_list />} /> 
                         <Route path="/page/:id"  element={<Page />} /> 
                         <Route path="/orders"  element={<Orders />} /> 
                         <Route path="/cart"  element={<Cart />} /> 
                         <Route path="/blog"  element={<Blog />} /> 
                         <Route path="/blog/:id"  element={<Blog_single />} /> 
                         <Route path="/cart/sub"  element={<CartSub />} /> 
                         <Route path="/course/:id" element={<Course_Single />} /> 
                         <Route path="/diet/:id" element={<Diet_Single />} /> 
                         <Route path="/training/:id" element={<Training_Single />} /> 
                         <Route path="/my/diet/:id" element={<My_Diet />} /> 
                         <Route path="/my/training/:id" element={<My_Training />} /> 
                         <Route path="/profile"  element={<Profile />} /> 
                         <Route path="/profile/edit"  element={<Profile_Edit />} /> 
                         <Route path="/profile/token/:stus" element={<Profile />} /> 
                         <Route path="/profile/Transaction"  element={<Transaction />} /> 
                         <Route path="/notfy"  element={<Notfy />} /> 
                         <Route path="/404" element={<P_404 />} /> 
                    </Routes> 


                </div>


            </div>





        )
    }
}


